import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.countdownInterval = null
    this.originalButtonText = 'Get OTP Code'
  }

  disconnect() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  }

  async request(event) {
    event.preventDefault()

    const button = event.currentTarget
    const phoneInput = this.element.querySelector('input[name="user[phone_number]"]')

    if (!phoneInput.value) {
      alert('Please enter your phone number first')
      return
    }

    button.disabled = true
    button.textContent = 'Sending...'

    try {
      const response = await fetch('/sign_up/users/request_otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ phone_number: phoneInput.value })
      })

      const data = await response.json()

      if (response.ok) {
        alert('Verification code sent! Please check your phone.')
        this.inputTarget.focus()
        this.startCountdown(button)
      } else {
        alert(data.error || 'Failed to send verification code. Please try again.')
        button.disabled = false
        button.textContent = this.originalButtonText
      }
    } catch (error) {
      console.error('Error:', error)
      alert('An error occurred. Please try again.')
      button.disabled = false
      button.textContent = this.originalButtonText
    }
  }

  startCountdown(button) {
    let timeLeft = 60

    const updateButton = () => {
      if (timeLeft > 0) {
        button.textContent = `Resend in ${timeLeft}s`
        timeLeft--
      } else {
        button.disabled = false
        button.textContent = this.originalButtonText
        clearInterval(this.countdownInterval)
        this.countdownInterval = null
      }
    }

    // Update immediately
    updateButton()

    // Then update every second
    this.countdownInterval = setInterval(updateButton, 1000)
  }
}